import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Users, GraduationCap } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const RoleSelect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setRole, user: authUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const user = location.state?.user || authUser;

  const handleRoleSelect = async (role) => {
    setLoading(true);
    try {
      // Use context's setRole which updates global state
      await setRole(role);
      toast.success(`Bem-vindo como ${role === 'teacher' ? 'Professor' : 'Aluno'}!`);
      
      if (role === 'teacher') {
        navigate('/teacher/dashboard', { replace: true });
      } else {
        navigate('/student/dashboard', { replace: true });
      }
    } catch (error) {
      console.error('Failed to set role:', error);
      toast.error('Erro ao definir perfil. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4">
      <div className="w-full max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-outfit font-black text-slate-900 mb-4" data-testid="role-select-title">
            Escolha seu Perfil
          </h1>
          <p className="text-lg text-slate-600 font-nunito">
            Olá, {user?.name}! Como você gostaria de usar o BelottoPokeClass Center?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <RoleCard
            icon={<GraduationCap className="w-16 h-16" />}
            title="Professor"
            description="Crie salas de aula, gerencie tarefas e acompanhe o progresso dos alunos."
            onClick={() => handleRoleSelect('teacher')}
            disabled={loading}
            testId="teacher-role-btn"
          />
          <RoleCard
            icon={<Users className="w-16 h-16" />}
            title="Aluno"
            description="Entre em salas de aula, choque ovos e evolua seu monstro completando tarefas."
            onClick={() => handleRoleSelect('student')}
            disabled={loading}
            testId="student-role-btn"
          />
        </div>
      </div>
    </div>
  );
};

const RoleCard = ({ icon, title, description, onClick, disabled, testId }) => {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className="bg-white rounded-2xl border-2 border-slate-100 p-10 shadow-sm hover:border-blue-200 hover:shadow-md hover:-translate-y-1 transition-all duration-200 cursor-pointer active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed text-left"
    >
      <div className="bg-blue-50 w-20 h-20 rounded-2xl flex items-center justify-center text-primary mb-6 mx-auto">
        {icon}
      </div>
      <h3 className="text-2xl font-outfit font-bold text-slate-900 mb-3 text-center">{title}</h3>
      <p className="text-slate-600 font-nunito leading-relaxed text-center">{description}</p>
    </button>
  );
};

export default RoleSelect;
